import { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

import type { TradeDateType } from '../cpOrderForm/input/cpOrderInputForm.model';

export type SecondaryMarketDominoSettlementDateActions =
  | SecondaryMarketDominoSettlementDateRequested
  | SecondaryMarketDominoSettlementDateReceived
  | SecondaryMarketDominoSettlementDateFetchFailed;

/////////////////////////////////////////////

export function secondaryMarketDominoSettlementDateRequested(
  tabId: string,
  bcsProductKey: BcsProductKey,
  valuationDate: string,
  cobDate: string | undefined,
  tradeDateType: TradeDateType | undefined,
  counterpartyEliotId: string | undefined,
  clientType: ClientType | undefined,
) {
  return {
    type: 'SECONDARY_MARKET_DOMINO_SETTLEMENT_DATE_REQUESTED' as const,
    bcsProductKey,
    tabId,
    valuationDate,
    cobDate,
    tradeDateType,
    counterpartyEliotId,
    clientType,
  };
}

export type SecondaryMarketDominoSettlementDateRequested = ReturnType<
  typeof secondaryMarketDominoSettlementDateRequested
>;
export function secondaryMarketDominoSettlementDateReceived(
  tabId: string,
  settlementDate: string | undefined,
  firstSettlementDate: string | undefined,
) {
  return {
    type: 'SECONDARY_MARKET_DOMINO_SETTLEMENT_DATE_RECEIVED' as const,
    tabId,
    settlementDate,
    firstSettlementDate,
  };
}

export type SecondaryMarketDominoSettlementDateReceived = ReturnType<
  typeof secondaryMarketDominoSettlementDateReceived
>;

///////////////////////////////////////////////

export function secondaryMarketDominoSettlementDateFetchFailed(
  tabId: string,
  bcsKey: BcsProductKey,
  errorMessage: string,
) {
  return {
    type: 'SECONDARY_MARKET_DOMINO_SETTLEMENT_DATE_FETCH_FAILED' as const,
    tabId,
    bcsKey,
    errorMessage,
  };
}

export type SecondaryMarketDominoSettlementDateFetchFailed = ReturnType<
  typeof secondaryMarketDominoSettlementDateFetchFailed
>;
